export enum paymentType {
  CARD = "CARD",
  BANK = "BANK",
  CASH = "CASH",
  OTHER = "OTHER",
}

export interface ICashPickupDetails {
  stateCode: string;
  payerId: string;
  payerName: string;
}

export interface IBankAccountDetails {
  source: "new" | "saved";
  bankId?: string;
  bankName?: string;
  accountNumber?: string;
  paymentMethodId?: string;
  last4?: string;
}

export interface IPaymentSelected {
  cardId: string | null;
  type: paymentType;
  brand: string;
  cashPickup?: ICashPickupDetails;
  bankAccount?: IBankAccountDetails;
}

export interface IPaymentState {
  payment: IPaymentSelected | null;
}

export interface IReceivetState {
  type: paymentType | null;
  receiveSelected: string | null;
  brand: string | null;
}
